import React, { useState, useEffect } from "react";
import Logo from "../../Assets/logo-transparent.png";
import Logo2 from "../../Assets/newAsset/footer.webp";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import { withRouter } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import { BiCartAlt } from "react-icons/bi";
import { Scroll } from "../Scroll function/scroll";
import { GiConsoleController, GiHamburgerMenu } from "react-icons/gi";
import { HiSearch } from "react-icons/hi";
import Searchbar from "../SearchBar/Searchbar";
import "../Header/header.css";
import { Modal } from "react-responsive-modal";
import LpForm from "../../Pages/packageDetailsPage/LpForm";
import NewPhoneModel from "../../Pages/homePage/Components/NewPhoneModel";
import {
  setMainSearch,
  getAllPackageList,
  getCartDetails,
} from "../../Redux/Actions";
import {
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaFacebookF,
} from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { FiUpload } from "react-icons/fi";
import PhoneModalTest from "../../Pages/homePage/Components/PhoneModal";
import { LazyLoadImage } from 'react-lazy-load-image-component';


const Header = ({ history, phone }) => {
  const dispatch = useDispatch();

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  const [showNavLinks, setShowNavLinks] = useState(false);
  const [Div, setDiv] = useState(true);

  //USER DETAILS
  const [userDetails, setUserDetails] = useState([]);

  //Getting data from localhost
  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    setUserDetails(userProfile);
  }, []);

  //getiing cart details
  const cartDetails = useSelector((state) => state.CartReducer);

  const [logOut, setLogout] = useState(false);
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("user"))) {
      const userProfile = JSON.parse(localStorage.getItem("user"));
      dispatch(getCartDetails(userProfile?.token, citySelect));
      setLogout(false);
    } else {
      setLogout(true);
    }
  }, []);

  const { loading: cartLoading, cartDetails: cartdata } = cartDetails;

  //MODEL FUNCTION HERE
  const [open, setOpen] = useState(false);

  const [cartLen, setCartLen] = useState(0);

  useEffect(() => {
    cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product.length &&
      setCartLen(
        cartDetails.cartDetails[0].product !== "" &&
          cartDetails.cartDetails[0].product.length > 0
          ? cartDetails.cartDetails[0].product.length
          : 0
      );
  }, [cartDetails]);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const [Hambuger, setHamburger] = useState(false);
  const [is_Active, setis_Active] = useState(false);

  const packageList = useSelector((state) => state.packageList);
  const { packages, loading } = packageList;

  const AllpackageList = useSelector((state) => state.allpackage);
  const { loading: loadingAllPackage, AllpackDetail } = AllpackageList;

  const [NewsearchTerm, setNewSearchTerm] = useState("");
  const [showSearch, setShowSearc] = useState(false);

  const getAllPackage = (e) => {
    e.preventDefault();
    const inputQuery = e.target[0].defaultValue;
    console.log(citySelect.toLowerCase());
    history.push({
      pathname: `/health-checkup-packages`,

      state: [AllpackDetail.results],
    });
    setNewSearchTerm("");
  };

  const NewhandleOnChange = (e) => {
    setDiv(true);
    setNewSearchTerm(e.target.value);
    if (e.target.value.length > 2) {
      setShowSearc(true);
      dispatch(getAllPackageList(e.target.value, citySelect));
    }
  };

  //FOR HOME SEARCH BAR MENU

  const handleOnChange = (e) => {
    e.preventDefault();
    setSearchTerm(e.target.value);
    // dispatch(setMainSearch(e.target.value));
  };
  const RemoveBars = (cityName) => {
    setis_Active(!is_Active);
    setDiv(false);
    setNewSearchTerm(cityName);
  };

  // console.log(citySelect,"Yo mam")
  return (
    <div className="headercontainer">
      <div className="header" id="header">
        <nav>
          <div className="header__leftSide">
            <GiHamburgerMenu
              className="Header_Hamburger"
              onClick={() => setHamburger(!Hambuger)}
            />
            <div
              className={
                Hambuger ? "Hamburger_design right" : "Hamburger_design "
              }
            >
              <div className={is_Active ? "Section-1st InnerSearchR" : "Section-1st"}>
                <div className="section-1st-logoImage">
                  <GiHamburgerMenu
                    fontSize="4rem"
                    className="icons_in_section-1st"
                    onClick={() => setHamburger(!Hambuger)}
                  />
                  <a href={process.env.RAZZLE_APP_BASE_URL} onClick={() => setHamburger(!Hambuger)}>
                    <LazyLoadImage src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp" alt="logo" className="top-logo" delayTime='100' defer />
                  </a>
                </div>
                {/**MOBILE CART ICONS */}

                <div className="two_icons_container">
                  <HiSearch
                    fontSize="3.5rem"
                    className="icons_in_section-1st"
                    onClick={() => setis_Active(!is_Active)}
                  />

                  {/* NEW SEARCH ICON  */}

                  {/* NEW SEARCH ICON CLOSED */}
                </div>
              </div>
              <div className="Section-2nd">
                <ul>
                  {/* <li>
                    <p className="font-design">
                      {" "}
                      <NavLink
                        exact
                        activeClassName="active_Link"
                        to="/about-us"
                      >
                        About Us
                      </NavLink>
                    </p>
                  </li> */}

                  {/* <li>
                    <p className="font-design" onClick={onOpenModal}>
                      Schedule a Pick-Up{" "}
                    </p>

                    <Modal open={open} onClose={onCloseModal} center>
                      <NewPhoneModel />
                    </Modal>
                  </li> */}

                  {/** **/}
                  <li>
                    <p className="font-design">
                      <NavLink
                        exact
                        activeClassName="active_Link"
                        to="/contact-us"
                      >
                        Contact Us
                      </NavLink>
                    </p>
                  </li>
              
                  <li>
                    <p className="font-design">
                      <NavLink
                        exact
                        activeClassName="active_Link"
                        to={`/health-checkup-packages${citySelect ? `-${citySelect
                          .toLowerCase()
                          .replace(" ", "-")}` : ''}`}

                        className="Few-Packages"
                      >
                        Health Packages
                      </NavLink>
                    </p>
                  </li>
                  {/* {userDetails ? (
                    <li>
                      <p className="font-design">
                        <NavLink exact activeClassName="active_Link" to="/cart">
                          My Cart
                        </NavLink>
                      </p>
                    </li>
                  ) : null} */}

                  <li>
                    <p className="font-design">
                      <NavLink
                        exact
                        activeClassName="active_Link"
                        to="/lab-centre-network"
                      >
                        Lab and Networks
                      </NavLink>
                    </p>
                  </li>
                  {userDetails ? null : (
                    <li>
                      <p className="font-design">
                        {" "}
                        <NavLink
                          exact
                        
                          to="/login"
                          className="Few-Packages"
                        >
                          Login
                        </NavLink>
                      </p>
                    </li>
                  )}

                  {/**UPLOAD PRESCRIPTION */}
                  {userDetails ? (
                    <li>
                      <p className="font-design">
                        <Link to="/uploadprescription">
                          Upload Prescription
                        </Link>
                      </p>
                    </li>
                  ) : (
                    <li>
                      <p className="font-design">
                        <Link
                          to={{
                            pathname: `/login`,
                            pushToUrl: "UploadPrescription",
                          }}
                        >
                          Upload Prescription
                        </Link>
                      </p>
                    </li>
                  )}
                </ul>
              </div>
              <div className="Section-3rd">
                <hr style={{ border: "1px solid  hsl(209, 73%, 33%)" }}></hr>
                <p className="font-design for-top"> Social </p>
                <ul className="ul_design_in_3rd_section">
                  <li>
                    <a
                      target="_blank"
                      href="https://www.instagram.com/redcliffelabs/"
                    >
                      {" "}
                      <FaInstagram
                        fontSize="3.5rem"
                        className="icon_design_in_3rd_section"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.facebook.com/RedcliffeLabs/"
                    >
                      <FaFacebookF
                        fontSize="3.5rem"
                        className="icon_design_in_3rd_section"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://twitter.com/redcliffelab">
                      <FaTwitter
                        fontSize="3.5rem"
                        className="icon_design_in_3rd_section"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/redcliffe-labs/"
                    >
                      <FaLinkedinIn
                        fontSize="3.5rem"
                        className="icon_design_in_3rd_section"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.youtube.com/c/RedcliffeLabs"
                    >
                      <FaYoutube
                        fontSize="3.5rem"
                        className="icon_design_in_3rd_section"
                      />{" "}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="img-container" onClick={() => 
              // history.push("/")
              window.location.href = process.env.RAZZLE_APP_BASE_URL
              }>
               {/* <LazyLoadImage src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg" alt="logo" width="110" height="auto" defer /> */}
               <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg" alt="logo" width="110" height="42" defer />
            </div>
            <div className="nav-links">
              <ul className="links-container">
                {/* <li className={""}>
                  <NavLink exact activeClassName="active_Link" to="/about-us">
                    About Us
                  </NavLink>
                </li> */}

                <li>
                  <NavLink
                    exact
                    activeClassName="active_Link"
                    to={`/health-checkup-packages${citySelect ? `-${citySelect
                      .toLowerCase()
                      .replace(" ", "-")}` : ''}`}
                    className="Few-Packages"
                  >
                    Health Packages
                  </NavLink>
                </li>
                <li className={""}>
                  <NavLink exact activeClassName="active_Link" to="/covid-19">
                    Covid 19
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="header__rightSide">
            <Searchbar />

            {/**UPLOAD PRESCRIPTION */}
            {userDetails ? (
              <div className="uploadDiv_PresForDesk">
                <Link
                  className="btn-secondary"
                  to="/uploadprescription"
                  style={{ fontSize: "1.4rem" }}
                >
                  <FiUpload /> Upload Prescription
                </Link>
              </div>
            ) : (
              <div className="uploadDiv_PresForDesk">
                <Link
                  className="btn-secondary"
                  to={{ pathname: `/login`, pushToUrl: "UploadPrescription" }}
                  style={{ fontSize: "1.4rem" }}
                >
                  <FiUpload />
                  Upload Prescription
                </Link>
              </div>
            )}

            {logOut ? null : userDetails ? (
              <span className="font-design CartBorder">
                <NavLink exact to="/cart">
                  <BiCartAlt
                    onClick={() => {
                      Scroll();
                    }}
                  />
                  {cartLen > 0 ? (
                    <span className="count">
                      {cartDetails &&
                        cartDetails.cartDetails &&
                        cartDetails.cartDetails[0] &&
                        cartDetails.cartDetails[0].product.length > 0 &&
                        cartDetails.cartDetails[0].product.length}
                    </span>
                  ) : null}
                </NavLink>
              </span>
            ) : null}

            <div className="hamIcon">
              <HiSearch
                onClick={() => setis_Active(!is_Active)}
                className="icons_in_section-1st"
              />
              <div className={is_Active ? "NewSearch right2" : "NewSearch"}>
                <div className="div_of_3_divs">
                  <HiSearch
                    fontSize="3.5rem"
                    value={{ className: "NewSearchIcon" }}
                  />

                  <form onSubmit={getAllPackage} className="NewSearchForm">
                    <input
                      type="text"
                      placeholder="Search test,health packages..."
                      value={NewsearchTerm}
                      onChange={NewhandleOnChange}
                    ></input>
                    <button type="submit" className="searchBtn"></button>
                  </form>
                  <ImCross
                    fontSize="23px"
                    onClick={() => setis_Active(!is_Active)}
                  />
                </div>
                {NewsearchTerm == "" ? null : Div ? (
                  NewsearchTerm.length > 3 ? (
                    <div className="searchedData">
                      {loadingAllPackage ? (
                        <Loader />
                      ) : (
                        AllpackDetail.results.map((value) => (
                          <Link
                            onClick={() => RemoveBars(value.name)}
                            to={`/${value.slug}-${citySelect.toLowerCase()}`}
                            className="searchLink"
                          >
                            {value.name}
                          </Link>
                        ))
                      )}
                    </div>
                  ) : null
                ) : null}
                <hr
                  style={{ border: "1px solid #dbdbdc", marginTop: "10px" }}
                ></hr>
                <div className="div_of_recom">
                  <ul>
                    <p> Featured</p>
                    <li onClick={() => setis_Active(!is_Active)}>
                      <p>
                        {" "}
                        <NavLink
                          className="AnchrOfRecom"
                          exact
                          activeClassName="active_Link"
                          to="/smart-full-body-checkup-noida"
                        >
                          {" "}
                          Smart Full Body Checkup{" "}
                        </NavLink>
                      </p>
                    </li>
                    <li onClick={() => setis_Active(!is_Active)}>
                      <p>
                        {" "}
                        <NavLink
                          className="AnchrOfRecom"
                          exact
                          activeClassName="active_Link"
                          to="/advance-full-body-checkup-noida"
                        >
                          Advance Full Body Checkup
                        </NavLink>
                      </p>
                    </li>

                    <li></li>
                  </ul>

                  <ul>
                    <p> Top-selling</p>
                    <li onClick={() => setis_Active(!is_Active)}>
                      <p>
                        {" "}
                        <NavLink
                          exact
                          activeClassName="active_Link"
                          to="fever-panel-test-with-rtpcr-noida"
                          style={{ color: " #003462" }}
                        >
                          {" "}
                          Fever Panel with RTPCR Test{" "}
                        </NavLink>
                      </p>
                    </li>
                    <li onClick={() => setis_Active(!is_Active)}>
                      <p>
                        {" "}
                        <NavLink
                          exact
                          activeClassName="active_Link"
                          to={`fever-panel-test-noida`}
                          className="Few-Packages"
                          style={{ color: " #003462" }}
                        >
                          {" "}
                          Fever Panel Test{" "}
                        </NavLink>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
        {showNavLinks && (
          <ul
            className="links-container-mobile"
            style={{ listStyleType: "none", marginTop: "1rem" }}
          >
            {/* <li className={""}>
              <NavLink exact activeClassName="active_Link" to="/about-us">
                About Us
              </NavLink>
            </li> */}
            <li className="Few-Packages">
              <NavLink
                exact
                activeClassName="active_Link"
                to={`/health-checkup-packages${citySelect ? `-${citySelect
                  .toLowerCase()
                  .replace(" ", "-")}` : ''}`}
              >
                Health Packages
              </NavLink>
            </li>
            <li className={""}>
              <NavLink exact activeClassName="active_Link" to="/covid-19">
                Covid 19
              </NavLink>
            </li>
            <li>
              <a href="tel:+918988988787">
                <button style={{ margin: "0 auto" }} className="btn-secondary">
                  898 898 8787
                </button>
              </a>
            </li>
          </ul>
        )}
      </div>
      <div className="test-package">
        <ul>
          <li>
            <a>Covid-19</a>
          </li>
          <li>
            <a>Smartbody Package</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default withRouter(React.memo(Header));
